import {
  //
  ADD_MEDICATION,
  ADD_MEDICATION_FAILURE,
  ADD_MEDICATION_SUCCESS,
  //
  DELETE_MEDICATION,
  DELETE_MEDICATION_FAILURE,
  DELETE_MEDICATION_SUCCESS,
  //
  EDIT_MEDICATION,
  EDIT_MEDICATION_FAILURE,
  EDIT_MEDICATION_SUCCESS,
  //
  FETCH_MEDICATION,
  FETCH_MEDICATION_FAILURE,
  FETCH_MEDICATION_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchMedication = (payload, onSuccess) => ({
  type: FETCH_MEDICATION,
  payload,
  onSuccess,
});
export const fetchMedicationSuccess = (payload) => ({
  type: FETCH_MEDICATION_SUCCESS,
  payload,
});
export const fetchMedicationFailure = (payload) => ({
  type: FETCH_MEDICATION_FAILURE,
  payload,
});
// View
export const getViewData = (payload, onSuccess) => ({
  type: GET_VIEW_DATA,
  payload,
  onSuccess,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addMedication = (payload, onAdd) => ({
  type: ADD_MEDICATION,
  payload,
  onAdd,
});
export const addMedicationSuccess = (payload) => ({
  type: ADD_MEDICATION_SUCCESS,
  payload,
});
export const addMedicationFailure = (payload) => ({
  type: ADD_MEDICATION_FAILURE,
  payload,
});
// EDIT
export const editMedication = (payload, onEdit) => ({
  type: EDIT_MEDICATION,
  payload,
  onEdit,
});
export const editMedicationSuccess = (payload, onEdit) => ({
  type: EDIT_MEDICATION_SUCCESS,
  payload,
});
export const editMedicationFailure = (payload) => ({
  type: EDIT_MEDICATION_FAILURE,
  payload,
});
// DELETE
export const deleteMedication = (payload, onDelete) => ({
  type: DELETE_MEDICATION,
  payload,
  onDelete,
});
export const deleteMedicationSuccess = (payload) => ({
  type: DELETE_MEDICATION_SUCCESS,
  payload,
});
export const deleteMedicationFailure = (payload) => ({
  type: DELETE_MEDICATION_FAILURE,
  payload,
});
